import { render } from "./scanNotFoundComponent.vue?vue&type=template&id=928ad34e&scoped=true&lang=true"
import script from "./scanNotFoundComponent.vue?vue&type=script&lang=js"
export * from "./scanNotFoundComponent.vue?vue&type=script&lang=js"

import "./scanNotFoundComponent.vue?vue&type=style&index=0&id=928ad34e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928ad34e"]])

export default __exports__